/**
 * Created by wajidafaneh on 4/26/17.
 */
window.HMAPMediaSettingsForm = function ($rootScope, $scope, registrationApi, $alert, Upload, brand) {
    var self = this;
    var formName = "hmap-media-settings-form";
    var _protected = BaseForm.call(self, formName, $scope);

    self.brand = brand;
    self.data = {
        icon: null,
        cover: null
    };

    self.isUploading = {
        'icon': false,
        'cover': false
    };

    self.showCroppingTool = function ($files, $file, $newFiles, $duplicateFiles, $invalidFiles, $event, type) {
        if ($files && $files[0]) {
            var fileType = Utils.getFileType($files[0]);
            if (fileType.indexOf("image/") > -1 && fileType.indexOf("image/gif") == -1) {
                var opt = {};
                opt['file'] = $files[0];
                opt['updateCoordsOnClose'] = true;
                opt['imageMode'] = type == 'cover'? type: null,

                opt['croppingModalCallBack'] = function (coords, image) {
                    var payload = {
                        name: $files[0].name,
                        type: type,
                        brand_id: self.brand.id,
                        x1: coords.x1,
                        y1: coords.y1,
                        x2: coords.x2,
                        y2: coords.y2,
                    };

                    self.isUploading[type] = true;

                    var uploadURL = publicConfiguration.getBaseAPI() + 'brand_profile_photo';
                    if(type === "cover") {
                        uploadURL = publicConfiguration.getBaseAPI() + 'brand_background_photo';
                    }

                    Upload.upload({
                        url: uploadURL,
                        withCredentials: true,
                        headers: {},
                        method: "PUT",
                        data: payload,
                        file: image
                    }).progress(function (evt) {
                    }).success(function (data, status, headers, config) {
                        self.isUploading[type] = false;

                        var image = registrationApi.generateBrandPhoto(
                            data.data,
                            type === 'icon' ? 'brand_profile_photo' : 'brand_background_photo'
                        );

                        self.data[type] = image;

                        setTimeout(function () {
                            $scope.$digest();
                        }, 1);
                    }).error(function (error) {
                        self.isUploading[type] = false;
                    });
                };

                // send selected files && show modal
                $rootScope.$broadcast('showImageCroppingModal', opt);
            }
            else {
                hAlert($filter("translate")("Invalid file type") + ": " + $files[0].name, $filter("translate")("Attachment should be image."))
            }
        } else if ($invalidFiles && $invalidFiles[0]) {
            hAlert($filter("translate")("The photo you uploaded is too small!"), $filter("translate")("It must be at least 800 pixels width and 600 pixels height."))
        }

        setTimeout(function () {
            $scope.$digest();
        }, 1);
    };

    //init
    (function () {
        registrationApi.getBrandBasicPhotos(brand.id).then(function (result) {
            self.data = result;
        });
    })();
};
